<template>
  <div :class="`formulate-input-element  formulate-input-element--${context.type}`"
    :data-type="context.type"
  >
    <div v-if="answers[getStep('DriverClaimHistory')][`year_claim_full_date_${context.name.substr(-1,1)}`] &&
               answers[getStep('DriverClaimHistory')][`month_claim_full_date_${context.name.substr(-1,1)}`]
    " class="notification is-info-palegreen">Your claim's history will update in <strong>{{ expiryDate(context.name.substr(-1,1)) }}</strong>, which will be reflected in your premium at the policy anniversary</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    context: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
        
    }
  },
  watch: {

  },
  computed: {
    ...mapGetters({
      answers: 'flattenedAnswers', 
      answerLabel: 'getAnswerLabel',
      getStep: 'getStep',
    }),
    
  },
  methods: {
    expiryDate(field_number){

      var fullMonth = {
        0: 'January',
        1: 'February',
        2: 'March',
        3: 'April',
        4: 'May',
        5: 'June',
        6: 'July',
        7: 'August',
        8: 'September',
        9: 'October',
        10: 'November',
        11: 'December'
      };

      var year = parseInt(this.answers[this.getStep('DriverClaimHistory')][`year_claim_full_date_${field_number}`]);
      var month = fullMonth[this.answers[this.getStep('DriverClaimHistory')][`month_claim_full_date_${field_number}`]];
      
      return month + ' ' + (year + 5)
    }
  },
}
</script>

<style>

</style>